export default defineI18nLocale(async (locale) => {
  const cmsStore = useCmsStore();

  const translations = cmsStore.translations[locale];
  if (translations) return translations;

  return cmsStore.fetchTranslations(locale);
});
